import { useRealTimeData } from "../hooks/useRealTimeData"
import AlertsTable from "../components/AlertsTable"

const AlertsPage = () => {
  const { alerts, acknowledgeAlert } = useRealTimeData()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Alert Management</h1>
        <p className="text-gray-600">View and manage all system alerts</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Live Alerts</h3>
          <p className="card-subtitle">Real-time security notifications</p>
        </div>
        <AlertsTable alerts={alerts} onAcknowledge={acknowledgeAlert} />
      </div>
    </div>
  )
}

export default AlertsPage

